import { useState } from 'react';
import List from './components/List';
import Edit from './components/Edit';
import Layout from '@src/components/layout/Layout';
import { Box, Paper, Typography } from '@mui/material';
import ProcedureDTO from '@src/adapters/dto/procedure/ProcedureDTO';

function Procedures() {
  const [selectedProcedure, setSelectedProcedure] = useState<ProcedureDTO>();
  const [updatedProcedure, setUpdatedProcedure] = useState<ProcedureDTO>();

  const handleCancel = () => {
    setSelectedProcedure(undefined);
  };

  const handleSaved = (procedure: ProcedureDTO) => {
    setUpdatedProcedure(procedure);
    setSelectedProcedure(undefined);
  };

  const handleSelectProcedure = (procedure: ProcedureDTO) => {
    setSelectedProcedure(procedure);
  };

  return (
    <Layout>
      <Box sx={{ padding: '0 20px 20px 20px', display: 'flex' }}>
        <Typography variant="h4">Procedures</Typography>
      </Box>
      <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <Paper
          elevation={8}
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            height: '80vh',
            width: '60%',
            overflow: 'auto',
          }}>
          <List
            selectProcedure={handleSelectProcedure}
            selectedProcedure={selectedProcedure}
            updatedProcedure={updatedProcedure}
          />
        </Paper>
        <Box sx={{ width: '38%' }}>
          {selectedProcedure && (
            <Edit
              procedure={selectedProcedure}
              cancel={handleCancel}
              saved={handleSaved}
            />
          )}
        </Box>
      </Box>
    </Layout>
  );
}

export default Procedures;
